import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import { Typography } from 'shared';

type ReplyToProps = {
  name: string;
  children: React.ReactNode;
};

export const ChatFormReplyTo = ({ name, children }: ReplyToProps) => {
  return (
    <Flex gap="var(--spacing01)" alignItems="center">
      <Typography type="small" color="black">
        Reply to
      </Typography>
      <Typography type="small" color="blue">
        {name}
      </Typography>
      <Box maxW="14rem">
        <Typography type="small" color="grayTotal" cropped>
          {children}
        </Typography>
      </Box>
    </Flex>
  );
};
